import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 flex flex-col lg:flex-row lg:justify-center gap-12 items-center text-left',
);

export const Title = w.h1(
  'text-4xl md:text-5xl xl:text-7xl text-[var(--azul)]'
)

export const SubText = w.p(
  'text-xl md:text-2xl xl:text-4xl mt-4 md:mt-4 text-[var(--azul)]'
)

export const Text = w.ul(
  'text-xl lg:text-2xl mt-10 md:mt-12 list-disc list-inside'
)

export const Image = w.img(
  ''
)

export const Btn = w.button(
  'relative text-white rounded-full bg-[var(--azul)] font-bold px-12 py-3 mt-16'
)

//  md:h-[462px] md:min-h-[462px] md:w-[518px] md:min-w-[518px] 